// © Microsoft Corporation. All rights reserved.

import { UrlUtility } from "./UrlUtility";
import { appEnvironment } from "../app/AppEnvironment";

export namespace LinkNavigation {

    /**
     * URL Prefix Lookup Table Constants
     * @export
     */
    export const contentUrlPrefixLookup = {
        article: "ar",
        video: "vi",
        slideshow: "ss"
    };

    /**
     * Generates a link to a topic xfeed using the current location for the origin and
     * the search string (Query String Parameters) and the passed in hostPage for its verticalKey and categoryKey.
     * @param topicId - an Id of a topic, for example Y_46b78bbb-31c4-4fc5-8a4a-858072348d06.
     * @param name - the name of a topic, for example "US News", this parameter will be encoded.
     * @return {string} - The generated URL.
     */
    export function generateTopicLink(topicId: string, name: string): string {
        const encodedName = UrlUtility.encodeURIComponentForPrime(name).toLowerCase();
        const { HostPage: hostPage } = appEnvironment;
        const xFeedSubcategory = "interests";

        if (hostPage) {
            const originUrl = new URL(hostPage.originalUrl);
            return originUrl.origin +
                "/" + hostPage.verticalKey +
                "/" + hostPage.categoryKey +
                "/" + xFeedSubcategory +
                "/" + encodedName +
                "/" + appEnvironment.CurrentMarket +
                "/f-" + topicId +
                originUrl.search;
        } else {
            // We don't have a host page we recognize, so there is no way to generate a proper Xfeed page Link, so just sent them to the homepage
            return "https://www.msn.com";
        }
    }

    /**
     * Generate the link for the content using the parameters passed and locale from the app-environment
     * @param category localized string for category
     * @param subCategory localized string for sub category
     * @param locale  locale string
     * @param contentId string indicating content id
     * @param uriTitle seo friendly headline
     * @param type string indicate the type of content
     */
    export function generateContentLink(category: string, subCategory: string, contentId: string, uriTitle: string, type: string): string {
        // If something is null/undefined, return default
        if (!category || !subCategory || !contentId || !uriTitle || !type) {
            return "/";
        }

        return `/${appEnvironment.CurrentMarket}/${category}/${subCategory}/${uriTitle}/${contentUrlPrefixLookup[type]}-${contentId}`;
    }
}
